import { render, staticRenderFns } from "./add_role.vue?vue&type=template&id=41c9495d&scoped=true&"
import script from "./add_role.vue?vue&type=script&lang=js&"
export * from "./add_role.vue?vue&type=script&lang=js&"
import style0 from "./add_role.vue?vue&type=style&index=0&id=41c9495d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9495d",
  null
  
)

export default component.exports